import {
  isLocalDev,
  isImagitasDev,
  isImagitasTest,
  isImagitasPreprod,
  isUspsDev,
  isUspsCat,
  isUspsSit,
} from '@mgo/core/src/environment';

export const getRecaptchaV2Key = () => '6LcoEDkUAAAAAPwZFuWfTqesYSQ3ypRmlgyVRuIL';
export const getRecaptchaV3Key = () => {
  const origin = window.location.href;

  switch (true) {
    case isLocalDev(origin):
    case isImagitasDev(origin):
    case isImagitasTest(origin):
    case isImagitasPreprod(origin):
    case isUspsDev(origin):
    case isUspsCat(origin):
    case isUspsSit(origin):
      sessionStorage.setItem('grcnonprod', true);
      return '6Le5ZIMbAAAAAJsypaFV_k5ThzHd1Qj4cSEMDjs-';
    default:
      return '6LddOKUbAAAAAGroS3hPKa2OtkbmWc7DEwBklD1m';
  }
};

// Recaptcha v3 explicit render onload callback
const addOnloadCallback = () => {
  const RC_KEY = getRecaptchaV3Key();
  window.rcErrHandling = (err) => window.console.error('reCAPTCHA V3 Error:', err);

  window.rcOnloadCb = () => {
    window.grecaptchaId = window.grecaptcha.render('grecaptcha-element', {
      sitekey: RC_KEY,
      size: 'invisible',
      'error-callback': window.rcErrHandling,
    });
  };
};

// https://developers.google.com/recaptcha/docs/faq#can-i-run-recaptcha-v2-and-v3-on-the-same-page
export default function (flagRecaptchaEnabled) {
  if (!flagRecaptchaEnabled) return flagRecaptchaEnabled;
  addOnloadCallback();
  const src = new URL('https://www.google.com/recaptcha/api.js');
  src.searchParams.set('render', 'explicit');
  src.searchParams.set('onload', 'rcOnloadCb');

  const nonProdKey = JSON.parse(sessionStorage.getItem('grcnonprod')) || false;
  if (flagRecaptchaEnabled && nonProdKey) {
    // eslint-disable-next-line no-console
    console.log('Not Production Recaptcha V3');
  }

  // Add recaptcha script
  const s = Object.assign(document.createElement('script'), {
    async: true, defer: true, src,
  });
  document.body.appendChild(s);
  return flagRecaptchaEnabled;
}
